import React, { useState, useEffect } from 'react';
import { ref, get, remove } from 'firebase/database';
import { deleteImmagine } from '../../utils/cloudinaryUtils';
import { database } from '../../firebase/config';
import { formattaData } from '../../utils/dateUtils';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { pdf } from '@react-pdf/renderer';




// ─────────────────────────────────────────────
// STILI PDF
// ─────────────────────────────────────────────
const pdfStyles = StyleSheet.create({
  page: { padding: 20, fontSize: 8, fontFamily: 'Helvetica' },
  intestazione: { flexDirection: 'row', alignItems: 'center', marginBottom: 8, paddingBottom: 6, borderBottom: '1 solid #ccc' },
  logoImg: { width: 60, height: 24, objectFit: 'contain' },
  recapiti: { marginLeft: 10, fontSize: 7, color: '#333' },
  recapitiNome: { fontSize: 8, fontWeight: 'bold', marginBottom: 1 },
  headerRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 },
  headerCell: { fontSize: 9 },
  headerCellBold: { fontSize: 9, fontWeight: 'bold' },
  title: { fontSize: 12, fontWeight: 'bold', textAlign: 'center', marginBottom: 8 },
  divider: { borderBottom: '1 solid #aaa', marginVertical: 4 },
  sectionTitle: { fontSize: 8, fontWeight: 'bold', backgroundColor: '#e0e0e0', padding: 2, marginBottom: 2 },
  row: { flexDirection: 'row', marginBottom: 2 },
  label: { fontWeight: 'bold', width: 100 },
  value: { flex: 1 },
  orarioRow: { flexDirection: 'row', gap: 12, marginBottom: 2 },
  orarioBlock: { flexDirection: 'row' },
  footer: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 8, paddingTop: 6, borderTop: '1 solid #aaa' },
  footerLabel: { fontWeight: 'bold', marginBottom: 1 },
  firmaBox: { marginTop: 6 },
  firmaImg: { width: 160, height: 60, border: '1 solid #999' },
});

// ─────────────────────────────────────────────
// COMPONENTE PDF
// ─────────────────────────────────────────────
function GiornalieraPDF({ dati }) {
  const { nomeDipendente, data, pausaInizio, pausaFine, lavori, oreTotali } = dati;
  // MODIFICA: oraFine obbligatoria per stampare il lavoro
  const lavoriValidi = (lavori || []).filter(l => (l.cantiereLabel || l.lavoroEseguito || l.oraInizio) && l.oraFine);

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <View style={pdfStyles.intestazione}>
          <Image src="CRG_logo.png" style={pdfStyles.logoImg} />
          <View style={pdfStyles.recapiti}>
            <Text style={pdfStyles.recapitiNome}>C.R.G. Scavi e trasporti Sagl</Text>
            <Text>Via Livio 5, 6830 Chiasso TI</Text>
            <Text>Tel +41 78 751 32 51 - email: info@crgscavi.ch</Text>
          </View>
        </View>

        <Text style={pdfStyles.title}>RAPPORTO GIORNALIERO</Text>

        <View style={pdfStyles.headerRow}>
          <Text style={pdfStyles.headerCellBold}>{nomeDipendente}</Text>
          <Text style={pdfStyles.headerCell}>{formattaData(data)}</Text>
        </View>

        <View style={pdfStyles.divider} />

        {lavoriValidi.map((lavoro, i) => (
          <View key={i}>
            <Text style={pdfStyles.sectionTitle}>Lavoro {i + 1}</Text>
            <View style={pdfStyles.row}>
              <Text style={pdfStyles.label}>Mezzo:</Text>
              <Text style={pdfStyles.value}>{lavoro.veicoloLabel || '-'}</Text>
            </View>
            <View style={pdfStyles.row}>
              <Text style={pdfStyles.label}>Lavoro eseguito:</Text>
              <Text style={pdfStyles.value}>{lavoro.lavoroEseguito || '-'}</Text>
            </View>
            <View style={pdfStyles.row}>
              <Text style={pdfStyles.label}>Cliente:</Text>
              <Text style={pdfStyles.value}>{lavoro.clienteLabel || '-'}</Text>
            </View>
            <View style={pdfStyles.row}>
              <Text style={pdfStyles.label}>Cantiere:</Text>
              <Text style={pdfStyles.value}>{lavoro.cantiereLabel || '-'}</Text>
            </View>
            <View style={pdfStyles.orarioRow}>
              <View style={pdfStyles.orarioBlock}>
                <Text style={pdfStyles.label}>Ora inizio: </Text>
                <Text>{lavoro.oraInizio || '-'}</Text>
              </View>
              <View style={pdfStyles.orarioBlock}>
                <Text style={pdfStyles.label}>Ora fine: </Text>
                <Text>{lavoro.oraFine || '-'}</Text>
              </View>
            </View>
            <View style={pdfStyles.divider} />
          </View>
        ))}

<View style={pdfStyles.footer}>
  <View>
    <Text style={pdfStyles.footerLabel}>Pausa pranzo</Text>
    {dati.assenza ? (
      <Text style={{ fontSize: 14, fontWeight: 'bold' }}>{dati.assenza}</Text>
    ) : (
      <Text>Inizio: {pausaInizio || '-'}   Fine: {pausaFine || '-'}</Text>
    )}
  </View>
  <View>
    <Text style={pdfStyles.footerLabel}>Ore totali lavorate</Text>
    <Text style={{ fontSize: 14, fontWeight: 'bold' }}>{oreTotali}</Text>
  </View>
</View>

{/* Firma dipendente */}
<View style={{ marginTop: 20, borderTop: '1 solid #aaa', paddingTop: 10 }}>
  <Text style={pdfStyles.footerLabel}>Firma dipendente</Text>
  <Text style={{ marginBottom: 6 }}>{nomeDipendente}</Text>
  {dati.firmaUrl
    ? <Image src={dati.firmaUrl} style={pdfStyles.firmaImg} />
    : <Text style={{ color: '#999' }}>Non firmato</Text>
  }
  {dati.modificatoIl && (
    <Text style={{ fontSize: 7, color: '#e74c3c', marginTop: 6, fontStyle: 'italic' }}>
      Modificata il: {dati.modificatoIl} — {nomeDipendente}
    </Text>
  )}
</View>
      </Page>
    </Document>
  );
}


function VisualizzaGiornaliera({ dipendente, onClose }) {
  const [giornaliere, setGiornaliere] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fotoSelezionata, setFotoSelezionata] = useState(null);
  const [filtroData, setFiltroData] = useState('');
  const [messaggioCancellazione, setMessaggioCancellazione] = useState('');
  const [generandoPdf, setGenerandoPdf] = useState(null);

  useEffect(() => {
    caricaDati();
  }, [dipendente]);

async function caricaDati() {
  setLoading(true);
  const snap = await get(ref(database, 'giornaliera'));
  if (snap.exists()) {
    const tutte = Object.keys(snap.val()).map(k => ({ id: k, ...snap.val()[k] }));
    const delDipendente = tutte
      .filter(g => g.dipendenteId === dipendente.id)
      .sort((a, b) => b.createdAt - a.createdAt);
    setGiornaliere(delDipendente);
  } else {
    setGiornaliere([]);
  }
  setLoading(false);
}


async function apriPDF(g) {
  setGenerandoPdf(g.id);
  try {
    const blob = await pdf(<GiornalieraPDF dati={g} />).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  } catch (err) {
    alert('Errore generazione PDF: ' + err.message);
  } finally {
    setGenerandoPdf(null);
  }
}


  const giornaliereFiltrate = filtroData
    ? giornaliere.filter(g => g.data === filtroData)
    : giornaliere;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-large"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>
            📋 Giornaliere — {dipendente.nome} {dipendente.cognome}
          </h2>
                            <button 
                onClick={onClose}
                style={{
                  background: '#e74c3c',
                  border: 'none',
                  color: 'white',
                  padding: '8px 15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  marginRight: '0px',
                  height: 'fit-content'
                }}
              >
                ✕
              </button>
        </div>

        {/* Filtro per data */}
        <div style={{ padding: '16px 24px', borderBottom: '1px solid #dee2e6' }}>
          <label style={{ marginRight: 8, fontWeight: 600 }}>Filtra per data:</label>
          <input
            type="date"
            value={filtroData}
            onChange={e => setFiltroData(e.target.value)}
          />
          {filtroData && (
            <button
              onClick={() => setFiltroData('')}
              style={{ marginLeft: 8, cursor: 'pointer', color: '#e74c3c', border: 'none', background: 'none', fontWeight: 700 }}
            >
              ✕ Rimuovi filtro
            </button>
          )}
        </div>

      {messaggioCancellazione && (
        <div style={{ margin: '12px 24px 0', padding: '8px 12px', background: '#eaffea', color: 'green', fontWeight: 600, borderRadius: 6 }}>
          {messaggioCancellazione}
        </div>
      )}

        <div style={{ padding: 24, overflowY: 'auto', maxHeight: '65vh' }}>
          {loading ? (
            <p>Caricamento...</p>
          ) : giornaliereFiltrate.length === 0 ? (
            <p style={{ color: '#7f8c8d' }}>
              {filtroData ? `Nessuna giornaliera per il ${formattaData(filtroData)}` : 'Nessuna giornaliera caricata'}
            </p>
          ) : (
            <>
              <p style={{ color: '#7f8c8d', marginBottom: 16 }}>
                {giornaliereFiltrate.length} {giornaliereFiltrate.length === 1 ? 'giornaliera' : 'giornaliere'}
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
  {giornaliereFiltrate.map(g => {

    // ── VECCHIO RECORD (upload foto) ──
    if (g.tipo !== 'form' && g.imageUrl) {
      return (
        <div key={g.id} className="foto-item" style={{ cursor: 'pointer' }} onClick={() => setFotoSelezionata(g)}>
          <img src={g.imageUrl} alt="Giornaliera" className="foto-thumb" />
          <small>{formattaData(g.data)}</small>
        </div>
      );
    }

    // ── NUOVO RECORD (form strutturato) ──
    if (g.tipo === 'form') {
      // MODIFICA: oraFine obbligatoria per mostrare il lavoro nel report admin
      const lavoriValidi = (g.lavori || []).filter(l => (l.cantiereLabel || l.lavoroEseguito || l.oraInizio) && l.oraFine);
      return (
        <div key={g.id} style={{ border: '1px solid #ddd', borderRadius: 8, padding: 16, background: '#fff' }}>

          {/* Header: nome dipendente sx — data dx */}
          {/* Header */}
<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12, borderBottom: '1px solid #eee', paddingBottom: 8, alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
  <strong style={{ fontSize: 15 }}>{g.nomeDipendente}</strong>
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
    {g.assenza && (
      <span style={{ fontSize: 11, color: g.assenza === 'MALATTIA' ? '#c0392b' : '#b9770e', background: g.assenza === 'MALATTIA' ? '#fdecea' : '#fff8e1', borderRadius: 4, padding: '2px 8px', fontWeight: 700, border: `1px solid ${g.assenza === 'MALATTIA' ? '#f5c6cb' : '#f0d58a'}` }}>
        {g.assenza}
      </span>
    )}
    {g.modificatoIl && (
      <span style={{ fontSize: 11, color: '#e67e22', background: '#fef9e7', borderRadius: 4, padding: '2px 8px', fontWeight: 600, border: '1px solid #f0c040' }}>
        ✏️ Modificata
      </span>
    )}
    <span style={{ color: '#555' }}>{formattaData(g.data)}</span>
  </div>
</div>

          {/* Sezioni lavoro */}
          {lavoriValidi.map((l, i) => (
            <div key={i} style={{ marginBottom: 10, padding: '8px 12px', background: '#f8f9fa', borderRadius: 6 }}>
              <div style={{ fontWeight: 700, marginBottom: 4, color: '#2c3e50' }}>Lavoro {i + 1}</div>
              {l.veicoloLabel && <div><strong>Mezzo:</strong> {l.veicoloLabel}</div>}
              {l.lavoroEseguito && <div><strong>Lavoro:</strong> {l.lavoroEseguito}</div>}
              {l.clienteLabel && <div><strong>Cliente:</strong> {l.clienteLabel}</div>}
              {l.cantiereLabel && <div><strong>Cantiere:</strong> {l.cantiereLabel}</div>}
              {(l.oraInizio || l.oraFine) && (
                <div><strong>Orario:</strong> {l.oraInizio || '-'} → {l.oraFine || '-'}</div>
              )}
            </div>
          ))}

          {/* Footer: pausa sx — ore totali dx */}
<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12, paddingTop: 8, borderTop: '1px solid #eee', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
  <div style={{ fontSize: 13, color: '#555' }}>
    <strong>Pausa:</strong> {g.assenza ? '-' : (g.pausaInizio || '-')} → {g.assenza ? '-' : (g.pausaFine || '-')}
  </div>

  {g.assenza ? (
    <div style={{
      fontWeight: 700,
      fontSize: 14,
      color: g.assenza === 'MALATTIA' ? '#c0392b' : '#e67e22',
      background: g.assenza === 'MALATTIA' ? '#fdecea' : '#fff6e5',
      padding: '4px 10px',
      borderRadius: 6,
      border: `1px solid ${g.assenza === 'MALATTIA' ? '#f5c6cb' : '#f5d08a'}`
    }}>
      {g.assenza}
    </div>
  ) : (
    <div style={{ fontWeight: 700, fontSize: 14, color: '#27ae60' }}>
      Ore totali: {g.oreTotali}
    </div>
  )}
</div>

{/* Pulsanti PDF + Elimina */}
<div style={{ marginTop: 12, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
  <button
    onClick={() => apriPDF(g)}
    disabled={generandoPdf === g.id}
    style={{ background: '#2980b9', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
  >
    {generandoPdf === g.id ? '...' : '📄 PDF'}
  </button>
  <button
    onClick={async () => {
      if (!window.confirm('Eliminare questa giornaliera?')) return;
      try {
        await remove(ref(database, `giornaliera/${g.id}`));
        await caricaDati();
        setMessaggioCancellazione('Giornaliera eliminata con successo!');
        setTimeout(() => setMessaggioCancellazione(''), 3000);
      } catch (e) {
        alert('Errore durante la cancellazione: ' + e.message);
      }
    }}
    style={{ background: '#e74c3c', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
  >
    Elimina
  </button>
</div>

        </div>
      );
    }

    return null;
  })}
</div>
            </>
          )}
        </div>
      </div>

      {/* Lightbox */}
      {fotoSelezionata && (
        <div
          className="modal-overlay"
          style={{ zIndex: 1100 }}
          onClick={() => setFotoSelezionata(null)}
        >
          <div
            className="modal-content"
            style={{ maxWidth: 700, textAlign: 'center' }}
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>Giornaliera del {formattaData(fotoSelezionata.data)}</h3>
              <button className="modal-close" onClick={() => setFotoSelezionata(null)}>✕</button>
            </div>
            <img
              src={fotoSelezionata.imageUrl}
              alt="Giornaliera"
              style={{ width: '100%', borderRadius: 8, marginTop: 12 }}
            />
                        <a
              href={fotoSelezionata.imageUrl}
              download
              target="_blank"
              rel="noreferrer"
              style={{ display: 'inline-block', marginTop: 12, color: '#667eea', fontWeight: 600 }}
            >
              ⬇️ Scarica foto
            </a>
            <button onClick={async () => {
              if (!window.confirm('Sei sicuro di voler cancellare definitivamente questa foto?')) return;
              try {
                await deleteImmagine(fotoSelezionata.publicId);
              } catch (e) {
                console.warn('Cloudinary non raggiunto', e.message);
              }
              try {
                await remove(ref(database, `giornaliera/${fotoSelezionata.id}`));
                setFotoSelezionata(null);
                await caricaDati();
                setMessaggioCancellazione('Foto cancellata con successo!');
                setTimeout(() => setMessaggioCancellazione(''), 3000);
              } catch (e) {
                alert('Errore durante la cancellazione: ' + e.message);
              }
            }} style={{ display: 'inline-block', marginTop: 12, marginLeft: 12, background: '#e74c3c', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
              Cancella foto
            </button>
          </div>
        </div>
      )}
    </div>

  );
}

export default VisualizzaGiornaliera;
